import React from 'react';

import './DetailListItem.scss';

export interface DetailListItemProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Description text displayed on the left side */
    description: React.ReactNode;
    /** Value text displayed on the right side */
    value: React.ReactNode;
}

const DetailListItem = ({ description, value, ...rest }: DetailListItemProps): React.JSX.Element => (
    <div className="kortbetjening-detail-list-item" {...rest}>
        <dt>{description}</dt>
        <dd className="semibold">{value}</dd>
    </div>
);

export default DetailListItem;
